import { classNames, useTranslate } from "helpers/common";
import { PaginationDirection } from "services/url";
import { CheckBox } from "ui/components/CheckBox";
import { Tooltip } from "ui/components/Tooltip";

import { TableHeaderProps } from "../types";

const TableHeader: React.FC<TableHeaderProps> = (props) => {
  const {
    columnProperties,
    selectableItems,
    rowCount,
    disableSelection,
    showSelectAll = true,
    numSelected,
    onSelectAllClick,
    sort,
    onSort,
    isChildTable,
    columnToggle,
  } = props;

  const { t } = useTranslate();

  const handleSortClicked = (field: string) => () => {
    if (sort && onSort) {
      // if clicked field is not currently sorted OR sort direction is desc, sort asc
      const direction =
        field !== sort.sortBy ||
          sort.direction === PaginationDirection.Descending
          ? PaginationDirection.Ascending
          : PaginationDirection.Descending;

      onSort({ sortBy: field, direction });
    }
  };

  return (
    <>
      <thead className="relative sticky bottom-4 z-10">
        <tr className={classNames(isChildTable ? "bg-slate-50" : " ")}>
          {selectableItems && (
            <th className={classNames(isChildTable ? "py-4 px-4 text-center " : "py-2 px-4 ")}>
              {showSelectAll && (
                <div className={classNames("flex items-center justify-center ")}>
                  <CheckBox
                    checked={numSelected === rowCount}
                    onChange={onSelectAllClick}
                    disabled={Boolean(disableSelection)}
                  />
                </div>
              )}
            </th>
          )}
          {columnProperties.map((property, index) => {
            const hasTooltip = !!property.tooltip;
            const tooltipClasses = hasTooltip
              ? "group cursor-help hover:underline hover:decoration-dotted hover:decoration-blue-600 underline-offset-4 hover:text-blue-600 transition-colors"
              : "";

            const titleNode = !!sort && property.sortable ? (
              <span
                className={classNames(
                  property.field === sort.sortBy ? "font-bold cursor-pointer" : "",
                  tooltipClasses
                )}
                onClick={handleSortClicked(property.field)}
              >
                {t(property.title)}
                {hasTooltip && (
                  <span className="ml-1 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity">?</span>
                )}
              </span>
            ) : (
              <span className={tooltipClasses}>
                {t(property.title)}
                {hasTooltip && (
                  <span className="ml-1 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity">?</span>
                )}
              </span>
            );

            return (
              <th
                key={index}
                scope="col"
                className={classNames("px-4 pt-3 pb-2 text-xs font-normal text-left text-slate-900 uppercase ", isChildTable ? "border-b border-slate-200" : "h-[48px]")}
              >
                {hasTooltip ? (
                  <Tooltip
                    variant="dark"
                    size="medium"
                    position="top-center"
                    description={t(property.tooltip!)}
                    trigger={titleNode}
                  />
                ) : (
                  titleNode
                )}
              </th>
            );
          })}

        </tr>
        {columnToggle && (
          <tr>
            <th colSpan={columnProperties.length + (selectableItems ? 1 : 0)} className="p-0 relative">
              <span className="absolute right-4 -top-[38px]">
                {columnToggle}
              </span>
            </th>
          </tr>
        )}
      </thead>

    </>
  );
};
export default TableHeader;
